module.exports = "/v2/pages/dashboard/dist/914cc90795343a1dc8dd0aeef2a8d3c8.svg";